import CircleIcon from '@mui/icons-material/Circle';
import KeyboardDoubleArrowUpOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowUpOutlined';
import { CircularProgress, Grid, styled } from '@mui/material';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { HiOutlineBriefcase } from 'react-icons/hi';
import { LuFileText, LuPencil } from 'react-icons/lu';
import { TbSend } from 'react-icons/tb';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  ICandidate,
  ICandidatesMergeDTO,
  IJob,
  getCandidateById,
  getJobCandidateAIMatchScores,
  getJobCandidateInteraction,
  mergeCandidates,
} from 'wisestep-api';
import {
  WsColors,
  WsTypoColors,
  WsTypography,
  WsDrawer,
  WsTypoVariants,
  Button,
  ICandidateAggregatedData,
  IConversationState,
  WsBadge,
  WsBadgeSize,
  WsBadgetype,
  // WsIconText,
} from 'wisestep-base';

import { accessDeniedNotoficationTxt } from '../../../../../components/AccessControl/AccessControl';
import { getCandidateLinkedInUrl } from '../../../../../features/candidateLayout/utils/CandidateHelper';
import { useCandidateViewData } from '../../../../../features/candidateLayout/utils/CandidateViewContext';
import { updateRTRDocs } from '../../../../../features/candidateLayout/utils/MergeCandidateHelper';
import MapConversationIcon from '../../../../../features/conversationWidget/components/MapConversationIcon';
import ViewDetailsDrawer from '../../../../../features/jobs/listing/components/viewDetails/ViewDetailsDrawer';
import { StyledAIMatchButton } from '../../../../../features/submissionsNew/components/widgets/AIMatchScoreButton';
import { CandidateAtsAccess, useCandidateAts } from '../../../../../hooks/useCandidateAts';
import { success, warning } from '../../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../../utils/NotificationStore';
import { useConversationWidgetStore } from '../../../../../utils/useConversationWidgetStore';
import ConversationWidgetDrawer from '../../../../conversationWidget/components/ConversationWidgetDrawer';
import JobSelection from '../../../../conversationWidget/components/JobSelection';
import conversationWidgetStore from '../../../../conversationWidget/store/conversationWidgetStore';

import ActionsBar, { Action } from './ActionBar';
import MergeCandidateBar from './MergeCandidateBar';

type ButtonType = {
  borderColor: string;
};
const IconButton = styled(Button)(({ borderColor }: ButtonType) => ({
  borderColor: borderColor,
}));
interface BottomBarProps {
  candidate: ICandidate;
  aggregation?: ICandidateAggregatedData | null;
  state?: IConversationState;
  setOpenConvoWidget: Dispatch<SetStateAction<boolean>>;
  openConvoWidget: boolean;
  closeMap?: () => void;
  openJobSelection: boolean;
  setOpenJobSelection: Dispatch<SetStateAction<boolean>>;
  openConvoWidgetFlag: boolean;
  setOpenConvoWidgetFlag: Dispatch<SetStateAction<boolean>>;
  setSubmissionPurpose: Dispatch<SetStateAction<string>>;
  submissionPurpose: string;
  setMappingPurpose: Dispatch<SetStateAction<string>>;
  mappingPurpose: string;
}

const BottomBar = ({
  candidate,
  state,
  openConvoWidget,
  setOpenConvoWidget,
  closeMap,
  openJobSelection,
  setOpenJobSelection,
  openConvoWidgetFlag,
  setOpenConvoWidgetFlag,
  setSubmissionPurpose,
  submissionPurpose,
  setMappingPurpose,
  mappingPurpose,
}: BottomBarProps) => {
  const { candidateViewData } = useCandidateViewData();
  const [showBottomBar, setShowBottomBar] = useState(false);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const updateAction = useConversationWidgetStore((state) => state.updateAction);
  const navigate = useNavigate();

  const [params] = useSearchParams();
  const interactionId = params.get('interaction');
  const openWidget = params.get('openConversationWidget');
  const openMergeCandidateBar = params.get('openMergeCandidateBar');
  const primaryCandidateId = params.get('primaryCandidateId');
  const id = params.get('id');
  const [showCandidateMergeBar, setShowCandidateMergeBar] = useState(() => {
    const storedFlag = localStorage.getItem('myFlag');
    return storedFlag !== null ? JSON.parse(storedFlag) : openMergeCandidateBar;
  });
  const isSubmitCandidate = useCandidateAts(CandidateAtsAccess.SUBMIT_CANDIDATE);
  const [submitCandidate, setSubmitCandidate] = useState<boolean>(false);

  const [questionAnswer, setQuestionAnswer] = useState<any>([]);
  const updatedState = {
    ...state,
    candidate: { ...candidate, questionResponse: questionAnswer },
  };
  const selectedJob = conversationWidgetStore((state) => state.selectedJob);
  const updateSelectedJob = conversationWidgetStore((state) => state.updateSelectedJob);
  const updateActivityConversation = useConversationWidgetStore(
    (state) => state.updateActivityConversation
  );
  const updateActionChangeJob = useConversationWidgetStore((state) => state.changeJob);
  const setupdateActionChangeJob = useConversationWidgetStore((state) => state.setChangeJob);
  const [jobEntity, setJobEntity] = useState<IJob | null>(selectedJob);
  const [primaryCandidate, setPrimaryCandidate] = useState<ICandidate>();
  const [selectTab, setSelectTab] = useState<string>('JD');
  const [openViewDetails, setOpenViewDetails] = useState<boolean>(false);
  const [load, setLoad] = useState<boolean>(false);
  const [score, setScore] = useState<number>(-1);
  const closeViewDetails = () => setOpenViewDetails(false);
  const toggleJobSelection = () => {
    setOpenJobSelection(!openJobSelection);
  };
  const closeDrawer = () => {
    setOpenConvoWidget(false);
    updateActivityConversation(null);
    setSubmitCandidate(false);
    setSubmissionPurpose('');
    setOpenConvoWidgetFlag(false);
  };
  let timeout: any;
  const handleMouseEnter = () => {
    clearTimeout(timeout);
    setShowBottomBar(true);
  };

  const handleMouseLeave = () => {
    timeout = setTimeout(() => {
      setShowBottomBar(false);
    }, 5000);
  };
  const selectedJobRef = useRef(selectedJob);

  useEffect(() => {
    if (openWidget === 'true') handleMapping();
  }, [openWidget]);

  useEffect(() => {
    if (openMergeCandidateBar === 'true' || showCandidateMergeBar === true) {
      localStorage.setItem('myFlag', openMergeCandidateBar ?? 'true');
      setShowBottomBar(true);
      setShowCandidateMergeBar(true);
    }
  }, [openMergeCandidateBar]);

  useEffect(() => {
    const getCandidateData = async () => {
      const primaryCandidate = await getCandidateById(primaryCandidateId ?? '');
      setPrimaryCandidate(primaryCandidate.data);
    };
    getCandidateData();
  }, [primaryCandidateId]);

  const mergeCandidate = async () => {
    const res = await mergeCandidates({
      newCandidateId: candidate?.candidateId ?? '',
      mergedCandidateId: primaryCandidate?.candidateId ?? '',
      emails: primaryCandidate?.email ?? [],
      newLink: primaryCandidate?.profileURLs ? primaryCandidate?.profileURLs[0] : '',
      phoneNumbers: primaryCandidate?.phoneNumber ?? [],
    } as ICandidatesMergeDTO);
    if (res?.data) {
      setNotification(success('Candidates Merged Successfully'));
      localStorage.setItem('myFlag', 'false');
      setShowBottomBar(false);
      setShowCandidateMergeBar(false);
      await updateRTRDocs(primaryCandidate?.candidateId ?? '', candidate?.candidateId ?? '');
      navigate(`/candidate-layout/profile?id=${id}`);
    } else {
      setNotification(warning('Merging Candidates Failed'));
    }
  };
  const handleDifferent = () => {
    setShowBottomBar(false);
    setShowCandidateMergeBar(false);
    localStorage.setItem('myFlag', 'false');
  };

  useEffect(() => {
    selectedJobRef.current = selectedJob;
  }, [selectedJob]);
  useEffect(() => {
    setJobEntity(selectedJob);
    setScore(-1);
    setLoad(false);
    return () => {
      clearTimeout(timeout);
    };
  }, [selectedJob, timeout]);

  useEffect(() => {
    const getdata = async () => {
      const req = await getJobCandidateInteraction(interactionId ?? '');
      setQuestionAnswer(req.data.questionResponse);
    };
    getdata();
  }, [interactionId]);

  useEffect(() => {
    const action = params.get('action');
    if (action === 'email' || action === 'sms') {
      if (selectedJobRef.current) {
        setOpenConvoWidget(true);
        updateAction(action);
      } else {
        setOpenJobSelection(true);
        setOpenConvoWidgetFlag(true);
      }
    }
  }, [params, setOpenConvoWidget, setOpenConvoWidgetFlag, setOpenJobSelection, updateAction]);
  const handleMapping = () => {
    updateAction('mapping');
    if (selectedJob) {
      setOpenConvoWidget(true);
      setMappingPurpose('mapping');
    } else {
      setOpenJobSelection(true);
      setOpenConvoWidgetFlag(true);
    }
  };
  const openJD = () => {
    setOpenViewDetails(true);
    setSelectTab('JD');
  };
  const handleAIMatchScore = async () => {
    setLoad(true);
    try {
      const res = await getJobCandidateAIMatchScores([
        {
          email: candidateViewData?.email ?? '',
          linkedInUrl: getCandidateLinkedInUrl(
            candidateViewData?.linkedInURL ?? '',
            candidateViewData?.profileURLs ?? []
          ),
          jobMatchingContent: [jobEntity?.title ?? '', jobEntity?.description ?? ''],
          jobSkills: jobEntity?.skills ?? [],
          jobTitle: jobEntity?.title ?? '',
        },
      ]);

      if (res?.data?.length) {
        setScore(res?.data?.[0].aiMatchScore);
      } else {
        setScore(0);
      }
    } catch (e) {
      console.error(e);
      setNotification(warning('SomeThing Went wrong'));
    } finally {
      setLoad(false);
    }
  };

  const handleSubmit = () => {
    if (isSubmitCandidate) {
      updateAction('submission');
      if (selectedJob) {
        setSubmitCandidate(true);
        setOpenConvoWidget(true);
      } else {
        setOpenJobSelection(true);
        setOpenConvoWidgetFlag(true);
      }
      setSubmissionPurpose('save');
    } else {
      setNotification(warning(accessDeniedNotoficationTxt));
    }
  };

  const actions: Action[] = [
    {
      id: 'jd',
      variant: 'text',
      label: 'JD',
      icon: <LuFileText />,
      show: !!jobEntity,
      onClick: openJD,
    },
    {
      id: 'change-select',
      variant: 'text',
      icon: jobEntity ? <LuPencil /> : <HiOutlineBriefcase />,
      label: jobEntity ? 'Change Job' : 'Select Job',
      show: true,
      onClick: toggleJobSelection,
    },
    {
      id: 'map',
      variant: 'text',
      label: 'Map as Lead',
      icon: <MapConversationIcon color={WsColors.TheBlues500} height={20} width={20} />,
      show: true,
      onClick: handleMapping,
    },
    {
      id: 'submit',
      variant: 'contained',
      label: 'Submit',
      show: !candidate?.isInDnc,
      icon: <TbSend />,
      onClick: handleSubmit,
    },
  ];

  return (
    <>
      <Grid
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          position: 'fixed',
          bottom: 2,
        }}
        container
        item
        display="flex"
        justifyContent="center"
        alignContent="center"
        zIndex={20}
        maxWidth={920}
      >
        {showBottomBar && showCandidateMergeBar && (
          <MergeCandidateBar
            candidate={primaryCandidate}
            handleDifferent={handleDifferent}
            mergeCandidate={mergeCandidate}
          />
        )}
        {showBottomBar && !showCandidateMergeBar && (
          <Grid
            item
            xs={12}
            p={2}
            sx={{ backgroundColor: WsColors.TheBlues900, boxShadow: 20 }}
            borderRadius={2}
            container
            alignItems="center"
            justifyContent="space-between"
            columnGap={1}
          >
            <Grid item xs={4}>
              <WsTypography color={WsTypoColors.WHITE} bold variant={WsTypoVariants.SUB_TITLE}>
                {jobEntity ? `${jobEntity.title}` : 'No Job Selected'}
              </WsTypography>
              <Grid display="flex" alignItems="center" columnGap={1}>
                {jobEntity && (
                  <WsBadge
                    label={jobEntity.jobCode ?? ''}
                    badgeSize={WsBadgeSize.LARGE}
                    badgeType={WsBadgetype.REOPENED}
                  />
                )}
                {jobEntity &&
                  (score === -1 ? (
                    <>
                      <CircleIcon color="secondary" sx={{ fontSize: 8 }} />
                      <StyledAIMatchButton
                        sx={{
                          color: WsColors.TheBlues500,
                          p: 0,
                          '&.Mui-disabled': {
                            color: WsColors.TheBlues500,
                          },
                          '&:hover': {
                            color: WsColors.TheBlues500,
                          },
                        }}
                        variant="text"
                        onClick={handleAIMatchScore}
                        disabled={load}
                        endIcon={load ? <CircularProgress size={20} /> : <></>}
                      >
                        Check AI Match score
                      </StyledAIMatchButton>
                    </>
                  ) : (
                    <WsBadge
                      label={`AI Match: ${score}%`}
                      badgeSize={WsBadgeSize.LARGE}
                      badgeType={WsBadgetype.SUCCESS}
                    />
                  ))}
              </Grid>
            </Grid>
            <Grid item xs={7} display="flex" justifyContent="flex-end">
              <ActionsBar actions={actions} />
            </Grid>
          </Grid>
        )}
        {!showBottomBar && (
          <Grid
            item
            xs={12}
            sx={{ backgroundColor: WsColors.TheBlues900 }}
            borderRadius={2}
            container
          >
            <Grid item xs={12} display="flex" justifyContent="center">
              <IconButton borderColor={''}>
                <KeyboardDoubleArrowUpOutlinedIcon />
              </IconButton>
            </Grid>
          </Grid>
        )}
        {(openJobSelection || updateActionChangeJob) && (
          <WsDrawer
            style={{ zIndex: '1300' }}
            size="medium"
            hideHeader={true}
            open={openJobSelection || updateActionChangeJob}
            onClose={() => {
              openJobSelection && toggleJobSelection();
              setOpenConvoWidgetFlag(false);
              setupdateActionChangeJob(false);
            }}
            hideOverflow={true}
          >
            <JobSelection
              getJob={(job) => {
                setJobEntity(job);
                updateSelectedJob(job);
                openJobSelection && toggleJobSelection();
                setOpenConvoWidget(openConvoWidgetFlag);
                setOpenConvoWidgetFlag(false);
                updateActionChangeJob && handleMapping();
                setupdateActionChangeJob(false);
              }}
              onBackButton={() => {
                openJobSelection && toggleJobSelection();
                setOpenConvoWidgetFlag(false);
                setupdateActionChangeJob(false);
              }}
              showMapSubmission={() => setSubmissionPurpose('save')}
            />
          </WsDrawer>
        )}
        <ConversationWidgetDrawer
          open={openConvoWidget}
          aggregation={null}
          recruiterAction={''}
          selectedJob={selectedJob}
          closeDrawer={closeDrawer}
          submitCandidate={submitCandidate}
          submissionPurpose={submissionPurpose}
          state={updatedState}
          isLayout={true}
          closeMap={closeMap}
          candidateViewData={candidateViewData}
          mappingPurpose={mappingPurpose}
        />
      </Grid>
      {jobEntity && (
        <ViewDetailsDrawer
          job={jobEntity}
          selectTab={selectTab == 'JD' ? 0 : 1}
          open={openViewDetails}
          closeDetails={closeViewDetails}
        />
      )}
    </>
  );
};
export default BottomBar;
